import { CoreToolboxComponentIds } from "../CoreToolboxComponentIds";
/**
 * Stores a reference to the canvas that the viewer draws to.
 * Recommended is to add this component to the SceneManager.root
 * (not the scene, as that will be replaced when loading)
 *
 * It is up to the planner to create this component. Don't forget to remove it
 * if the canvas is disposed of.
 */
var CanvasComponent = /** @class */ (function () {
    function CanvasComponent(canvas) {
        this.canvas = canvas;
        this.typeId = CanvasComponent.ID;
        this.serializable = false;
        // Since viewers may change between snapshots we must recreate thisx
        this.doStoreInSnapshot = false;
    }
    CanvasComponent.prototype.eq = function (other) {
        return other.canvas === this.canvas;
    };
    CanvasComponent.ID = CoreToolboxComponentIds.CanvasComponentId;
    return CanvasComponent;
}());
export { CanvasComponent };
//# sourceMappingURL=CanvasComponent.js.map